if (!customElements.get("m-blog-posts")) {
  class MBlogPosts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: "m:grid",
        hidden: "m:hidden",
        swiper: "swiper-container",
        swiperWrapper: "swiper-wrapper",
      };

      this.slider = false;
      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 3;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;
      if (
        typeof MinimogTheme !== "undefined" &&
        MinimogTheme.config &&
        MinimogTheme.config.mqlMobile &&
        this.mobileDisableSlider
      ) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const slideContainer = this.querySelector(this.selectors.slideContainer);
      const slideInner = this.querySelector(this.selectors.slideInner);
      const slideControls = this.querySelector(this.selectors.slideControls);

      if (!slideContainer || !slideInner) return;

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

      this.options = {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: false,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        navigation:
          this.showNavigation && (nextButton || prevButton)
            ? {
                nextEl: nextButton,
                prevEl: prevButton,
              }
            : false,
        breakpoints: {
          480: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: Math.min(2, this.items),
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: Math.min(3, this.items),
            spaceBetween: 12,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: 12,
          },
        },
      };

      if (typeof this.slider !== "object" || !this.slider) {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        if (slideControls) slideControls.classList.remove(this.classes.hidden);

        if (typeof MinimogLibs !== "undefined" && MinimogLibs.Swiper) {
          this.slider = new MinimogLibs.Swiper(slideContainer, this.options);
        } else if (typeof Swiper !== "undefined") {
          this.slider = new Swiper(slideContainer, this.options);
        }
      }
    }

    destroySlider() {
      const slideContainer = this.querySelector(this.selectors.slideContainer);
      const slideInner = this.querySelector(this.selectors.slideInner);
      const slideControls = this.querySelector(this.selectors.slideControls);

      if (slideContainer) slideContainer.classList.remove(this.classes.swiper);
      if (slideInner) {
        slideInner.classList.remove(this.classes.swiperWrapper);
        slideInner.classList.add(this.classes.grid);
      }
      if (slideControls) slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === "object" && this.slider) {
        if (typeof this.slider.destroy === "function") {
          this.slider.destroy(true, true);
        }
        this.slider = false;
      }
    }
  }

  customElements.define("m-blog-posts", MBlogPosts);
}
